// removed by extract-text-webpack-plugin
module.exports = {"root":"root___21pZ8","detail-label":"detail-label___34Ym3","detail-content":"detail-content___2ywAj","detail-content-skus":"detail-content-skus___16phw","detail-img":"detail-img___1oER6"};


//////////////////
// WEBPACK FOOTER
// ./src/components_business/GoodsDetailModal/Index.less
// module id = nC1r
// module chunks = 0 9 12 13 25 26